import { Router } from '@angular/router';
import { IonSearchbar, ToastController } from '@ionic/angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Constants } from 'src/app/config/constants';
import { StorageService } from 'src/app/lib/services/storage.service';
import { CatalogueService } from 'src/app/lib/services/catalouge.service';
import { CommonService } from 'src/app/lib/services/common.service';
import { ProductsService } from 'src/app/lib/services/products.service';
import { LanguageService } from 'src/app/lib/services/language.service';

@Component({
    selector: 'app-product-search',
    templateUrl: './product-search.component.html',
    styleUrls: ['./product-search.component.scss'],
    standalone: false
})
export class ProductSearchComponent implements OnInit {
  suggestion: any;
  searchquery: any;
  searchresult: any;
  masterCatalog: any;
  searchSegment: String;
  selectedCategory: any;
  categorysegment: String;
  selectedCategoryInCatalog: any;
  @ViewChild('searchBar') searchBar: IonSearchbar;

  constructor(
    private router: Router,
    public commonService: CommonService,
    private storageService: StorageService,
    private languageService: LanguageService,
    private productsService: ProductsService,
    private toastController: ToastController,
    private catalogueService: CatalogueService,
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.searchSegment = "products";
  }

  async ionViewDidEnter() {
    this.searchBar.setFocus();
    const catalogPresentInStorage = await this.storageService.getItemNativeCatalog(Constants.MASTER_CATALOGUE);
    this.masterCatalog = JSON.parse(catalogPresentInStorage);
    const selectedCategories = await this.storageService.getItemNativeCatalog(Constants.SELECTED_CATEGORIES);
    this.selectedCategoryInCatalog = JSON.parse(selectedCategories);
  }

  search(event: any) {
    if (event.key === 'Enter') {
      this.productSearch(this.searchBar.value);
    }
  }

  async searchSuggestions(e: any) {
    const query = e.target.value?.toLowerCase();
    if (!query) {
      this.suggestion = '';
      return; // No need to proceed if query is empty
    }
    try {
      this.commonService.presentProgressBarLoading();
      const res: any = await this.catalogueService.productSearchSuggestions({ "query": query }).toPromise();
      this.commonService.closeProgressBarLoading();
      if (res && res.data) {
        if (res.data.suggestions) {
          this.suggestion = res.data.suggestions;
        } else if (res.data.message) {
          this.commonService.toast(res.data.message);
        } else {
          this.commonService.danger('Something went wrong! Please try again later');
        }
      } else {
        this.commonService.danger('Unexpected response from the server. Please try again later.');
      }
    } catch (error) {
      console.error(error);
      this.commonService.closeProgressBarLoading();
      this.commonService.errorToast(error);
    }
  }

  async productSearch(query: any) {
    this.searchquery = query;
    const search = {
      product: query,
      url: this.catalogueService.retailerCatalog
    };
    this.clearSearch();
    try {
      this.commonService.presentProgressBarLoading();
      const res: any = await this.catalogueService.elasticSearch(search).toPromise();
      this.commonService.closeProgressBarLoading();
      if (res && res.data && res.data.all_products && res.data.categories) {
        this.searchresult = res.data;
        this.extractProducts(res.data);
        this.selectCategory(res.data.categories[0]);
      } else {
        this.commonService.danger('Something went wrong! Please try again later');
      }
    } catch (error) {
      this.commonService.closeProgressBarLoading();
      console.error(error);
      this.commonService.errorToast(error);
    }
  }

  clearSearch() {
    this.suggestion = '';
    this.searchBar.value = '';
    return;
  }

  extractProducts(apiResponse: any) {
    this.checkProductsInMyCatalog(apiResponse.all_products);
    apiResponse.categories.forEach((category: any) => {
      this.checkProductsInMyCatalog(category.products);
    });
  }

  checkProductsInMyCatalog(products: any[]) {
    products.forEach((product: any) => {
      if (product.status === 'pending' || product.status === 'published' || product.status === 'unpublished') {
        product.checked = true;
      }
    });
  }

  selectCategory(category: any) {
    this.selectedCategory = category;
  }

  async updateProduct(productobject: any, isChecked: any) {
    if (productobject.status === 'published') {
      productobject.checked = true;
      this.commonService.danger('Published products cannot be unselected.');
      return;
    }
    let targetProducts: any[];
    if (this.searchSegment === 'products') { // Search product in categories
      targetProducts = await this.searchresult?.categories.flatMap((category: any) =>
        category.products.filter((prod: any) => prod.id === productobject.id)
      );
    } else if (this.searchSegment === 'category') { // Search product in all_products
      const prod = await this.searchresult?.all_products.find((prod: any) => prod.id === productobject.id);
      targetProducts = prod ? [prod] : [];
    } else {
      return;
    }
    targetProducts.forEach((prod: any) => { // Updating checked status
      prod.checked = isChecked;
    });
    if (isChecked) {
      productobject = await this.setStatus(productobject);
      this.addCategory(productobject);
      await this.updateCatelog(productobject, isChecked);
    } else {
      await this.updateCatelog(productobject, isChecked);
    }
  }

  async addCategory(productobject: any) {
    let productCategory = productobject.catPnm.split('/')[0].replace(/[_]/g, '');
    const exists = this.selectedCategoryInCatalog.some((obj: any) => obj.name.toLowerCase().replace(/\s+/g, '') === productCategory.toLowerCase());
    if (!exists) {
      const category = this.masterCatalog.masterCatalogData.catalog.find((obj: any) => obj.name.toLowerCase().replace(/\s+/g, '') === productCategory);
      if (category && category.categoriesUrl) {
        this.languageService.selectLanguageCDN(category.categoriesUrl).subscribe(async (categories: any) => {
          await this.selectedCategoryInCatalog.push(categories);
          this.storageService.setItemNativeCatalog(Constants.SELECTED_CATEGORIES, this.selectedCategoryInCatalog);
        }, err => {
          console.log(err);
          const message = this.commonService.getTranslatedMessage('Failed to add') || 'Failed to add';
          this.commonService.danger(`${message} ${category.name}`);
        });
      } else {
        this.commonService.danger('Something went wrong! Please try again later');
      }
    }
  }

  async setStatus(product: any) {
    if (this.searchSegment === 'category') {
      const prod = await this.searchresult?.all_products.find((prodbject: any) => prodbject.id === product.id);
      prod.status = 'pending';
      return prod;
    } else if (this.searchSegment === 'products') {
      product.status = 'pending';
      return product;
    }
  }

  async updateCatelog(product: any, isChecked: any) {
    const addPopup = this.commonService.getTranslatedMessage('Added in your catalog') || 'Added in your catalog';
    const removePopup = this.commonService.getTranslatedMessage('Removed from your catalog') || 'Removed from your catalog';
    const data = isChecked ? { products: [product], removedProducts: [] } : { products: [], removedProducts: [product] };
    // this.commonService.presentProgressBarLoading();
    const loading = await this.commonService.presentLoader();
    loading.present();
    try {
      const response: any = await this.productsService.insertCatalogData(data).toPromise();
      // this.commonService.closeProgressBarLoading();
      await loading.dismiss();
      if (response.success) {
        isChecked ? this.presentToast(`${product.prdNm}, ${addPopup}`, 'success') : this.presentToast(`${product.prdNm}, ${removePopup}`, 'warning');
      } else {
        this.commonService.danger('An unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // this.commonService.closeProgressBarLoading();
      await loading.dismiss();
      this.commonService.errorToast(error);
    }
  }

  async presentToast(msg: any, color: any) {
    let isToastPresented: boolean;
    if (isToastPresented) {
      this.toastController.dismiss();
      isToastPresented = false;
    }
    const message = this.commonService.getTranslatedMessage(msg) || msg;
    const toast = await this.toastController.create({
      message,
      duration: 1000,
      position: "top",
      mode: 'ios',
      color: color
    });
    isToastPresented = true;
    await toast.present();
  }

  routeToHome() {
    this.router.navigate(['home']);
  }

  onAdd() {
    this.storageService.getItemNativeCatalog(Constants.SELECTED_CATEGORIES).then(result => {
      if (result) {
        this.router.navigate(['select-food']);
      } else {
        this.router.navigate(['select-category']);
      }
    })
  }

}